var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadiusFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.5,
    stroke: "#F9D87A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8636 13.9345H21.2159C21.5407 13.9345 21.804 14.1978 21.804 14.5225C21.804 14.8473 21.5407 15.1106 21.2159 15.1106H18.8636V15.3066C18.8636 17.0388 17.4594 18.443 15.7273 18.443H15.5312V20.7953C15.5312 21.1201 15.268 21.3833 14.9432 21.3833C14.6184 21.3833 14.3551 21.1201 14.3551 20.7953V18.443H12.3949V20.7953C12.3949 21.1201 12.1316 21.3833 11.8068 21.3833C11.482 21.3833 11.2187 21.1201 11.2187 20.7953V18.443H11.0227C9.29055 18.443 7.88636 17.0388 7.88636 15.3066V15.1106H5.53408C5.2093 15.1106 4.94601 14.8473 4.94601 14.5225C4.94601 14.1978 5.2093 13.9345 5.53408 13.9345H7.88636V11.9743H5.53408C5.2093 11.9743 4.94601 11.711 4.94601 11.3862C4.94601 11.0614 5.2093 10.7981 5.53408 10.7981H7.88636V10.6021C7.88636 8.86993 9.29055 7.46573 11.0227 7.46573H11.2187V5.11346C11.2187 4.78868 11.482 4.52539 11.8068 4.52539C12.1316 4.52539 12.3949 4.78868 12.3949 5.11346V7.46573H14.3551V5.11346C14.3551 4.78868 14.6184 4.52539 14.9432 4.52539C15.268 4.52539 15.5312 4.78868 15.5312 5.11346V7.46573H15.7273C17.4594 7.46573 18.8636 8.86993 18.8636 10.6021V10.7981H21.2159C21.5407 10.7981 21.804 11.0614 21.804 11.3862C21.804 11.711 21.5407 11.9743 21.2159 11.9743H18.8636V13.9345ZM16.052 15.6314C16.3461 15.3373 16.5114 14.9385 16.5114 14.5226V11.3862C16.5114 10.5201 15.8093 9.818 14.9432 9.818H11.8068C10.9407 9.818 10.2386 10.5201 10.2386 11.3862V14.5226C10.2386 15.3886 10.9407 16.0907 11.8068 16.0907H14.9432C15.3591 16.0907 15.758 15.9255 16.052 15.6314Z",
    fill: "#F5BB19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0227 11.3521C11.0227 10.9379 11.3585 10.6021 11.7727 10.6021H14.9773C15.3915 10.6021 15.7273 10.9379 15.7273 11.3521V14.5566C15.7273 14.9709 15.3915 15.3066 14.9773 15.3066H11.7727C11.3585 15.3066 11.0227 14.9709 11.0227 14.5566V11.3521Z",
    fill: "#F5BB19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiusFrame);
export default __webpack_public_path__ + "static/media/RadiusFrame.a76cebc447b5a7cb9a66658278a84a9c.svg";
export { ForwardRef as ReactComponent };